(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("react-pricing-table", [], factory);
	else if(typeof exports === 'object')
		exports["react-pricing-table"] = factory();
	else
		root["react-pricing-table"] = factory();
})(this, function() {
return 


// WEBPACK FOOTER //
// webpack/universalModuleDefinition